import { itemSerialize } from '../knowledgeBases/serializers'

// eslint-disable-next-line import/prefer-default-export
export const userProfile = (data) => ({
  cnpj: data.cnpj,
  name: data.name,
  company_name: data.companyName,
  regionalOffice: data.regionalOffice,
  profileImageUrl: data.profileImageUrl,
  subsidiaryName: data.subsidiaryName,
  networkName: data.networkName,
  email: data.email,
  phoneNumberCell: data.phoneNumberCell,
  contentFavorites: data.contentFavorites.map(itemSerialize)
})
